import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS } from "@/data/content";
import { GoldDivider } from "@/components/GoldDivider";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="velvet-deep text-ivory pt-20 pb-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <img src="/logo-crest.png" alt="West Ouachita Cabinets" className="h-40 w-auto rounded-[3px] ring-1 ring-gold/25 -ml-1" />
            <p className="text-[#A9B7CE] mt-5 max-w-xs leading-relaxed">
              Fine custom cabinetry built by hand in West Monroe, Louisiana. Solid wood. Made here.
            </p>
          </div>
          <div>
            <h4 className="font-serif text-2xl mb-5">Visit The Shop</h4>
            <ul className="space-y-3 text-[#A1B0C4]">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-gold shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>{BUSINESS.addressLine}<br />{BUSINESS.serviceArea}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-gold shrink-0" strokeWidth={1.5} />
                <a href={BUSINESS.phoneHref} className="hover:text-gold transition-colors" data-testid="footer-phone">
                  {BUSINESS.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-gold shrink-0" strokeWidth={1.5} />
                <a href={`mailto:${BUSINESS.email}`} className="hover:text-gold transition-colors">{BUSINESS.email}</a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-serif text-2xl mb-5">Explore</h4>
            <ul className="space-y-3 text-[#A1B0C4]">
              <li><Link to="/portfolio" className="hover:text-gold transition-colors">Portfolio</Link></li>
              <li><Link to="/process" className="hover:text-gold transition-colors">Process</Link></li>
              <li><Link to="/about" className="hover:text-gold transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>

        <GoldDivider className="my-10" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-[#A1B0C4] text-xs tracking-wide">
          <p>&copy; {new Date().getFullYear()} West Ouachita Cabinets. All rights reserved.</p>
          <p className="tracking-luxe uppercase">Serving {BUSINESS.serviceArea}</p>
        </div>
      </div>
    </footer>
  );
}
